import Vue from 'vue';
import model from '@zj/model';

Vue.mixin({
  methods: {
    exit() {
      this.$router.go(-1);
    },
  },
});

Vue.component('model', model);
